export const reconnectDelay = 100;
export const heartbeatIncoming = 1000;
export const heartbeatOutgoing = 1000;
